import {Card} from "@components";
import VadImage from "vadimages-nextjs-image-optimizer";
import OrangeArrow from "@/parts/TipsTricksSection/OrangeArrow";
import React from "react";
import * as Api from "@api";

interface ITipsTricksCardProps
{
    pageContent: Record<string, Api.ContentItem>;
    slug: string;
    sectionSlug: string;
    productType: string;
}

const TipsTricksCard = ({ pageContent, slug, sectionSlug, productType }: ITipsTricksCardProps) => {
    return (
        <Card className="p-10">
            <h4 className="text-center">
                {pageContent[`${sectionSlug}.${slug}.headline`]?.data}
            </h4>
            <div className={`relative w-full h-[200px] my-12`}>
                <VadImage
                    className={`absolute inset-0 object-contain w-full h-full ${slug === 'leaf' ? 'scale-125 top-10' : ''}`}
                    src={`images/products/${productType}/active-${slug === 'root-root-xl' ? 'root' : slug}/product.${slug === 'leaf' ? 'with-lines.' : ''}png`}
                    alt={'Nav Thumb'}
                    width={266}
                    height={200}
                />
            </div>
            <div className='relative mb-6 mt-20'>
                <p className='text-center font-semibold'>
                    {pageContent[`${sectionSlug}.${slug}.battery-indicator`]?.data
                        ?? 'Indicator light on bottom'}</p>
                {
                    slug !== 'leaf' && <OrangeArrow slug={slug} />
                }
            </div>
            <div dangerouslySetInnerHTML={{ __html: pageContent[`${sectionSlug}.${slug}.body`].data }} />
        </Card>
    )
}

export default TipsTricksCard;
